import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { RightPanelDialogService } from '../../../../@core/utils/right-panel-dialog.service';

@Component({
  selector: 'app-base-drawer',
  template: '',
  standalone: true,
})
export abstract class BaseDrawerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() visible: boolean = false;

  protected readonly sideFormLevelService = inject(RightPanelDialogService);
  private registered = false;

  ngOnInit(): void {
    if (this.visible && !this.registered) {
      this.sideFormLevelService.register();
      this.registered = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      if (this.visible && !this.registered) {
        this.sideFormLevelService.register();
        this.registered = true;
      } else if (!this.visible && this.registered) {
        this.sideFormLevelService.unregister();
        this.registered = false;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.registered) {
      this.sideFormLevelService.unregister();
      this.registered = false;
    }
  }
}
